<template>
  <div class="box box--file">
    <span class="box-tag">
      <span>{{box.type.toUpperCase()}}</span>
      <span>{{box.humanSize}}</span>
      <span>{{box.createdAt | formatDate2}}</span>
    </span>
    <span class="box-title"><i class="icon-file-pdf"></i> {{box.name}}</span>
    <p>{{box.fileDescription}}</p>
    <div class="box-menu">
      <button class="box-menu-button" @click="showMenu = ! showMenu"><i class="icon-more"></i></button>
      <transition name="fade">
        <div class="box-menu-dropdown" v-if="showMenu">
          <a class="link-icon" target="_blank" @click="showMenu = false" :href="`https://engage.edge.capgemini.com/api/filepreview/${box.idFile}`"><i class="icon-eye"></i> <span>Preview</span></a>
          <a class="link-icon" download @click="showMenu = false" :href="`https://engage.edge.capgemini.com/api/file/${box.idFile}`"><i class="icon-download"></i> <span>Download</span></a>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "BoxFile",
  props: ['box'],
  data () {
    return {
      showMenu: false
    }
  }
}
</script>
